/* eslint-disable import/prefer-default-export */
export const DatabaseScheme = {
  databaseSchemeRequest: 'DATABASE_SCHEME_PENDING',
  databaseSchemeSuccess: 'DATABASE_SCHEME_SUCCESS',
};
